import React, { useState, useLayoutEffect } from 'react';

const LangContext = React.createContext({
  lang: '',
  currentLangData: {},
  switchLang: () => { },
});

export default LangContext;

export function LangProvider(props) {

  const [lang, setLang] = useState(localStorage.getItem('appUILang') || 'es-ES');


  useLayoutEffect(() => {
    const selectedLang = localStorage.getItem('appUILang');

    if (selectedLang) {
      setLang(selectedLang);
    }
  }, [lang])

  const switchLang = (ln) => {
    setLang(ln);
    localStorage.setItem('appUILang', ln);
  };

  return (
    <LangContext.Provider value={{
      lang,
      switchLang,
      currentLangData: langData[lang]
    }}>
      {props.children}
    </LangContext.Provider>
  );
};

const langData = {
  'en-US': {
        NAVIGATION: {
            proyectos: 'Projects',
            habilidades: 'Capabilities',
            herramientas: 'Skills & Tools',
            contacto: 'Contact',
            sendMessage: 'Send Message'
        },
        HERO: {
            title_1: `Hi, I'm Rodrigo 👋`,
            title_2: 'Front-end & Mobile Developer',
            desc: 'Passionate about the front-end and mobile, I always seek to keep updated and in search of new technological trends.',
            cta: 'See Projects',
            about: 'About me'
        },
        PROYECTOS: {
            title: 'Projects',
            subtitle: 'Digital Products (Apps, Websites, Dashboards) and design systems which are visually pleasing, user-centric and easy to use.',
            more_projects: 'More Projects',
            CARD: {
                READEE: {
                    slug: 'Web platform development',
                    desc: 'Readee is a magazine hub that works based on subscriptions, where you can find content such as: Digital Magazines, Articles and Videos.',
                    bullets: ['Layout from 0 of the entire site', 'Functional Components',' Site translation (English & Spanish) via hooks and react context ',' Handling of application states with react context ',' Full Responsive ',' Token-based application for requests ',' Integration with payment gateway, to make collections and register cards ',' PDF viewer (for digital magazines) ',' Login with Google, Facebook, Apple Connect ',' Digital tours for new features', 'React Hooks',' Google Web Push Notifications']
                },
                READEE_DASHBOARD: {
                    slug: 'Web dashboard development',
                    desc: 'Dashboard for the creation of content for the Readee platform.'                    ,
                    bullets: ['Layout from 0 of the entire site', 'Functional Components',' Application status management with react context ',' Full Responsive ',' Digital tours for new functionalities', 'React Hooks',' Application based on roles and permissions for each role ',' Application based on tokens for requests', 'CRUDs for content creation (articles, videos, brands, numbers), users',' KPIs'] 
                },
                TIIM_DASHBOARD: {
                    slug: 'Web dashboard development',
                    desc: 'Tiim is a private collective transport service system'                    ,
                    bullets: ['Layout from 0 of the entire site', 'Functional Components', 'Handling of application states with react context', 'Full Responsive', 'React Hooks', 'Application based on roles and permissions for each role', 'Token-based application for requests',' KPIs', 'CRUDs for dashboard users, drivers, vehicles, routes, stops, notifications, promotions',' Billing ',' Integration with Google Firebase ',' Chat in time real with Google Firebase '] 
                },
                RESTAURANTES: {
                    slug: 'Web dashboard development',
                    desc: '"Restaurants" is a system for the control and management of restaurants, through the dashboard you can see various kpis in real time.',
                    bullets: ['Layout from 0 of the entire site', 'Functional Components', 'Handling of application states with react context', 'Full Responsive', 'React Hooks', 'Application based on roles and permissions for each role', 'Token-based application for requests', 'KPIs', 'Socket.io integration to consume real-time transaction data', 'Integration with google maps'] 
                },
                PROCUREMENT: {
                    slug: 'Web platform development',
                    desc: 'Procurement is a dashboard for information control'                    ,
                    bullets: ['Layout from 0 of the whole site', 'Functional Components', 'Handling of application states with react context', 'Full Responsive', 'React Hooks'] 
                },
                OFFICE: {
                    slug: 'Web development & design of the landing page',
                    desc: 'Home Office Solutions is a network that gives employees accessibility to a business network. The development and design of the landing page was carried out '                    ,
                    bullets: ['Layout from 0 of the whole site', 'Functional Components', 'Handling of application states with react context', 'Full Responsive', 'React Hooks', 'Integration with Leaflet for maps'] 
                },
                NEMEMES: {
                    slug: 'App Development',
                    desc: 'Nememes is a mobile application for Android and iOS, to share, follow, like and publish content (social network).'                    ,
                    bullets: ['Layout from 0', 'Functional Components',' React Hooks and React Context ',' Login with Facebook ',' Use of device camera ',' Push Notifications (One Signal) ',' Infinite Scroll for paginated loading content ',' React Native '] 
                },
                WITTINK: {
                    slug: 'App Development',
                    desc: 'Wittink is a mobile application for Android and iOS, to share, follow, like and publish content (social network).'                    ,
                    bullets: ['Layout from 0', 'Functional Components',' Login with Facebook ',' Login with Twitter ',' Use of device camera ',' Push Notifications (AWS) ',' Ionic ',' Cordova ',' Infinite Scroll to load content page ']
                },
                TANKEN_TERMINAL: {
                    slug: 'App Development',
                    desc: 'Tanken Terminal is a mobile application for Android (Famucos), for reading tags via NFC'                    ,
                    bullets: ['Layout from 0', 'Functional Components',' Use of the NFC reader ',' React Native ']
                },
                BUNKER: {
                    slug: 'App Development',
                    desc: 'Bunker is an application for andrpid and iOS for contact management with a business approach',
                    bullets: ['Layout from 0', 'Functional Components', 'Expo - React Native', 'Google maps', 'Access to contacts', 'Use of the device camera']
                },
                PECOP: {
                    slug: 'App Development',
                    desc: "PECOP is an application for android and iOS for the state of Veracruz that seeks to provide transparency in public works under construction."                    ,
                    bullets: ['Layout from 0', 'Functional Components', 'Framework 7', 'Google maps with multiple pins', 'QR scanner', 'Use of device camera', 'KPIs', 'Cordova']
                }
            }
        },
        HABILIDADES: {
            title: 'Capabilities'
        },
        HERRAMIENTAS: {
            title: 'Languages, Tools & Libraries',
            subtitle: 'For those who know what they’re looking for...'
        },
        CONTACTO: {
            title: 'In need of a Front-end / Mobile developer?',
            subtitle: 'I’m currently available for freelance work.',
        },
        FOOTER: {
            title: 'Designed and 💻 by Rodrigo Salmerón | Done with 💜 and React'
        }
  },
  'es-ES': {
        NAVIGATION: {
            proyectos: 'Proyectos',
            habilidades: 'Habilidades',
            herramientas: 'Herramientas',
            contacto: 'Contacto',
            sendMessage: 'Mandar Mensaje',
        },
        HERO: {
            title_1: 'Hola, Soy Rodrigo 👋',
            title_2: 'Desarrollador Front-end & Mobile',
            desc: 'Apasionado por el front-end y mobile, busco siempre mantenerme actualizado y en búsqueda de las nuevas tendencias tecnológicas.',
            cta: 'Ver Proyectos',
            about: 'Acerca de mí'
        },
        PROYECTOS: {
            title: 'Proyectos',
            subtitle: 'Productos digitales (aplicaciones móviles, sitios web, plataformas web) y sistemas de diseño visualmente agradables, centrados en el usuario y fáciles de usar.',
            more_projects: 'Más proyectos',
            CARD: {
                READEE: {
                    slug: 'Desarrollo de la plataforma web',
                    desc: 'Readee es un hub de revistas que funciona a base de suscripciones, donde puedes encontrar contenido como: Revistas Digitales, Artículos y Videos.',
                    bullets: ['Maquetación desde 0 de todo el sitio', 'Componentes Funcionales', 'Traducción del sitio(ingles & español) vía hooks y react context', 'Manejo de estados de la aplicación con react context', 'Full Responsive', 'Aplicación basada en tokens para las peticiones', 'Integración con pasarela de pagos, para realizar cobros y dar de alta tarjetas', 'Visor de PDF(para las revistas digitales)', 'Login con Google, Facebook, Apple Connect', 'Tours digitales para nuevas funcionalidades', 'React Hooks', 'Google Web Push Notifications']
                },
                READEE_DASHBOARD: {
                    slug: 'Desarrollo de la dashboard web',
                    desc: 'Dashboard para la creación del contenido para la plataforma de  Readee.',
                    bullets: ['Maquetación desde 0 de todo el sitio', 'Componentes Funcionales', 'Manejo de estados de la aplicación con react context', 'Full Responsive','Tours digitales para nuevas funcionalidades', 'React Hooks', 'Aplicación basada en roles y permisos por cada rol', 'Aplicación basada en tokens para las peticiones', 'CRUDs para creación de contenido(artículos, videos, marcas, números), usuarios', 'KPIs'] 
                },
                TIIM_DASHBOARD: {
                    slug: 'Desarrollo de la dashboard web',
                    desc: 'Tiim es un sistema de servicio de transporte colectivo privado',
                    bullets: ['Maquetación desde 0 de todo el sitio', 'Componentes Funcionales', 'Manejo de estados de la aplicación con react context', 'Full Responsive', 'React Hooks', 'Aplicación basada en roles y permisos por cada rol', 'Aplicación basada en tokens para las peticiones', 'KPIs', 'CRUDs para usuarios de la dashboard, conductores, vehículos, rutas, paradas, notificaciones, promociones', 'Facturación', 'Integración con Google Firebase', 'Chat en tiempo real con Google Firebase'] 
                },
                RESTAURANTES: {
                    slug: 'Desarrollo de la dashboard web',
                    desc: '“Restaurantes” es un sistema para el control y gestión de restaurantes, por medio de la dashboard se pueden ver diversos kpis en tiempo real.',
                    bullets: ['Maquetación desde 0 de todo el sitio', 'Componentes Funcionales', 'Manejo de estados de la aplicación con react context', 'Full Responsive', 'React Hooks', 'Aplicación basada en roles y permisos por cada rol', 'Aplicación basada en tokens para las peticiones', 'KPIs', 'Integración de socket.io para consumir los datos en tiempo real de transacciones', 'Integración con google maps'] 
                },
                PROCUREMENT: {
                    slug: 'Desarrollo de la plataforma web',
                    desc: 'Procurement es una dashboard para el control de información',
                    bullets: ['Maquetación desde 0 de todo el sitio', 'Componentes Funcionales', 'Manejo de estados de la aplicación con react context', 'Full Responsive', 'React Hooks'] 
                },
                OFFICE: {
                    slug: 'Desarrollo y diseño de la landing page',
                    desc: 'Home Office Solutions es una red que brinda a los empleados accesibilidad a una red empresarial. Se realizó el desarrollo y el diseño de la landing page',
                    bullets: ['Maquetación desde 0 de todo el sitio', 'Componentes Funcionales', 'Manejo de estados de la aplicación con react context', 'Full Responsive', 'React Hooks', 'Integración con Leaflet para mapas'] 
                },
                NEMEMES: {
                    slug: 'Desarrollo de la app',
                    desc: 'Nememes es una aplicación móvil para Android y iOS, para compartir, seguir, likear y publicar contenido(red social).',
                    bullets: ['Maquetación desde 0', 'Componentes Funcionales', 'React Hooks y React Context', 'Login con Facebook', 'Uso de cámara del dispositivo', 'Push Notifications(One Signal)', 'Infinite Scroll para la carga paginada de contenido', 'React Native'] 
                },
                WITTINK: {
                    slug: 'Desarrollo de la app',
                    desc: 'Wittink es una aplicación móvil para Android y iOS, para compartir, seguir, likear y publicar contenido(red social).',
                    bullets: ['Maquetación desde 0', 'Componentes Funcionales', 'Login con Facebook', 'Login con Twitter', 'Uso de cámara del dispositivo', 'Push Notifications(AWS)', 'Ionic', 'Cordova', 'Infinite Scroll para la carga pagina de contenido']
                },
                TANKEN_TERMINAL: {
                    slug: 'Desarrollo de la app',
                    desc: 'Tanken Terminal es una aplicación móvil para Android(Famucos), para la lectura de tags vía NFC',
                    bullets: ['Maquetación desde 0', 'Componentes Funcionales', 'Uso del lector NFC', 'React Native']
                },
                BUNKER: {
                    slug: 'Desarrollo de la app',
                    desc: 'Búnker es una aplicación para andrpid y iOS para la gestión de contacto con enfoque empresarial',
                    bullets: ['Maquetación desde 0', 'Componentes Funcionales', 'Expo - React Native', 'Google maps', 'Acceso a contactos', 'Uso de la cámara del dispositivo']
                },
                PECOP: {
                    slug: 'Desarrollo de la app',
                    desc: 'PECOP es una aplicación para android y iOS para el estado de Veracruz que busca servir en la transparencia de las obras públicas en construcción.',
                    bullets: ['Maquetación desde 0', 'Componentes Funcionales', 'Framework 7', 'Google maps con múltiples pines', 'QR scanner', 'Uso de la cámara del dispositivo', 'KPIs', 'Cordova']
                }
            }
        },
        HABILIDADES: {
            title: 'Habilidades'
        },
        HERRAMIENTAS: {
            title: 'Lenguajes, Herramientas & Librerias',
            subtitle: 'Para aquellos que saben lo que andan buscando...'
        },
        CONTACTO: {
            title: '¿Estas buscando un desarrollador Front-end / Mobile?',
            subtitle: 'Actualmente estoy disponible para trabajos freelance',
        },
        FOOTER: {
            title: 'Diseñado y 💻 por Rodrigo Salmerón | Hecho con 💜 y React'
        }
  }
}